import {MutableRefObject, useEffect, useRef} from 'react'

export function useIsMountedRef(): MutableRefObject<boolean> {
  const isMounted = useRef(false)

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  return isMounted
}
